import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming/Context.js';
import { AppInitializing } from '@/screens/Initializing';
import { getAppDefaultPaths } from './utils';

export function BrandingInitializedGuard(props: ChildrenProps) {
  const { query } = useContext(AppThemingContext);

  if (query.isLoading) return <AppInitializing />;

  return props.children;
}

type AuthenticatedGuardProps = {
  children: React.ReactNode;
  unauthenticatedRedirectPath?: string;
};

export function BrandingAccessGuard(props: AuthenticatedGuardProps) {
  const defaultPaths = getAppDefaultPaths();
  const hasBrandingPermission = false;

  if (!hasBrandingPermission) {
    return (
      <Navigate
        to={props.unauthenticatedRedirectPath || defaultPaths.home}
        replace />
    );
  }

  return props.children;
}